/**
 * Generates an integer by hashing a CUID using its last 8 characters (the
 * random portion). This is useful for deterministically "randomizing" something.
 * For example, mod the result to get a consistent choice from a list of options.
 */
const getIntegerFromIdViaHash = (id: string): number => {
  const randomPartOfId = id.slice(-8);

  // Modified from https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
  let hash = 0;
  for (let i = 0; i < 8; i++) {
    const char = randomPartOfId.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return Math.abs(hash);
};

/**
 * Randomly choose an option from the provided `options``. This is deterministic, so
 * it will always pick the same random option based off of the provided `id`.
 */
export const pickItemFromArrayDeterministicallyUsingId = <T>(options: T[], id: string): T => {
  const seed = getIntegerFromIdViaHash(id);

  // 1 option -- Return it
  if (options.length === 1) {
    return options[0];
  }

  // 2+ options -- Pick one using the seed
  return options[seed % options.length];
};

/**
 * Predicate function for .filter()
 * @param value
 */
export function isNotNull<TValue>(value: TValue | null): value is TValue {
  return value !== null;
}
